import React, { useCallback, useState } from 'react'
import Button from '_components/button'
import { Typography, Menu, MenuItem } from '@material-ui/core'

import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'

import classNames from 'classnames'
import useStyles from './styles'
import { useParams, navigate } from '@reach/router'
import { ROUTES } from '_/utils/constants'
import { agencySelector } from '_/modules/agency/selectors'
import { useSelector } from 'react-redux'
import { PERMISSIONS, PERMISSIONS_ACTIONS } from '_/utils/constants/permissions'
import useRolePermission from '_/hooks/use-role-permission'

export function AdditionalConfigButton({ key = 'additional-config', disabled = false }) {
  const styles = useStyles()
  const agency = useSelector(agencySelector)
  const agencyJS = agency?.toJS()
  const { checkUserPermission } = useRolePermission()

  const [anchorEl, setAnchorEl] = useState(null)

  const { agencyId } = useParams()

  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleGoToClassificationList = useCallback(() => {
    navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.CLASSIFICATION_LIST}`)
  }, [agencyId])

  const handleGoToMacroStepsList = useCallback(() => {
    navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.MACRO_STEPS}`)
  }, [agencyId])

  const handleGoToConfigEmail = useCallback(() => {
    navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.ADDITIONAL_CONFIG_EMAIL}`)
  }, [agencyId])

  const handleGoToVIPClientsList = useCallback(() => {
    navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.VIP_CLIENTS_LIST}`)
  }, [agencyId])

  const handleGoToBuildingsList = useCallback(() => {
    navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.BUILDINGS_LIST}`)
  }, [])

  const handleGoToProvidersList = useCallback(() => {
    return checkUserPermission({
      permission: PERMISSIONS.INTERMEDIARY_CONFIGS,
      permissionAction: [PERMISSIONS_ACTIONS.ADD, PERMISSIONS_ACTIONS.EDIT],
      functionAccess: () => {
        navigate(`${ROUTES.AGENCY}/${agencyId}/prestadores`)
      },
    })
  }, [agencyId, checkUserPermission])

  const handleGoToWebhooksList = useCallback(() => {
    navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.WEBHOOK_LIST}`)
  }, [])

  const handleGoToManageKanban = useCallback(() => {
    return checkUserPermission({
      permission: PERMISSIONS.KANBAN,
      permissionAction: [PERMISSIONS_ACTIONS.ADD, PERMISSIONS_ACTIONS.EDIT],
      functionAccess: () => {
        navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.KANBAN_CONFIG}`)
      },
    })
  }, [agencyId, checkUserPermission])

  const handleGoToConnectionConfig = useCallback(() => {
    return checkUserPermission({
      permission: PERMISSIONS.MESSENGER,
      permissionAction: PERMISSIONS_ACTIONS.READ,
      functionAccess: () => {
        navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.CONNECTION_CONFIG}`)
      },
    })
  }, [agencyId, checkUserPermission])

  return (
    <div>
      <Button
        id={`${key}-button`}
        key={key}
        className={classNames(styles.button)}
        onClick={handleClick}
        color="primary"
        variant="outlined"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disabled={disabled}
        endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
      >
        <Typography>Dados adicionais</Typography>
      </Button>

      <Menu
        id={`${key}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': `${key}-button`,
        }}
        PaperProps={{
          style: {
            marginTop: 46,
            marginLeft: 0,
            width: 180,
          },
        }}
      >
        <MenuItem onClick={handleGoToClassificationList}>Classificações</MenuItem>
        <MenuItem onClick={handleGoToVIPClientsList}>Clientes VIP</MenuItem>
        <MenuItem onClick={handleGoToMacroStepsList}>Etapas para clientes</MenuItem>
        <MenuItem onClick={handleGoToManageKanban}>Kanban</MenuItem>
        {agency?.contractType === 'SAAS' && (
          <MenuItem onClick={handleGoToConfigEmail}>Provedor de email</MenuItem>
        )}
        {agencyJS?.areaOfActivity?.enterpriseManagement && (
          <MenuItem color="primary" variant="contained" onClick={handleGoToBuildingsList}>
            {agency?.propertiesTerm ? agency?.propertiesTerm : 'Empreendimentos'}
          </MenuItem>
        )}
        {agency?.contractType !== 'SAAS' && agencyJS?.areaOfActivity?.providerAssociation && (
          <MenuItem onClick={handleGoToProvidersList}>Prestadores</MenuItem>
        )}
        <MenuItem onClick={handleGoToWebhooksList}>Webhooks</MenuItem>
        {agency?.contractType === 'SAAS' && agencyJS?.autoMessagingSaas && (
          <MenuItem onClick={handleGoToConnectionConfig}>Config. de conexão</MenuItem>
        )}
      </Menu>
    </div>
  )
}
